const ar = {
  // ── Navbar ──
  "nav.home": "الرئيسية",
  "nav.aviation": "أخبار الطيران",
  "nav.hotels": "الفنادق",
  "nav.destinations": "الوجهات",
  "nav.videos": "فيديو",
  "nav.gcc": "دليل الخليج",
  "nav.opinion": "مقالات الرأي",
  "nav.about": "عن الصحيفة",
  "nav.advertise": "الإعلان معنا",
  "nav.contact": "اتصل بنا",
  "nav.pdfEdition": "السياحية PDF",
  "nav.search": "ابحث في الأخبار...",
  "nav.searchResults": "نتائج سريعة",
  "nav.searchAll": "عرض كل نتائج",
  "nav.searchEmpty": "لا توجد نتائج لـ",
  "nav.searchFull": "بحث شامل",
  "nav.searchLoading": "جاري البحث...",
  "nav.langToggle": "EN",
  "nav.topBarDate": "الأربعاء، 22 أبريل 2026",
  "nav.topBarSlogan": "الصحيفة السياحية الأولى في الخليج",
  "nav.breaking": "عاجل",
  "nav.breakingText": "مطار دبي يستقبل 92 مليون مسافر في 2025 ← وزارة السياحة السعودية تُعلن عن 40 وجهة جديدة ← قطر تستضيف مؤتمر السياحة العالمي 2027 ← الإمارات تحصد جائزة أفضل وجهة سياحية عربية للعام الثالث على التوالي ←",

  // ── Footer ──
  "footer.followUs": "تابعنا على",
  "footer.about": "صحيفة إلكترونية يومية متخصصة في أخبار السفر والسياحة في منطقة الخليج العربي والعالم.",
  "footer.location": "المنامة، مملكة البحرين",
  "footer.newsTitle": "الأقسام الإخبارية",
  "footer.specialTitle": "أقسام خاصة",
  "footer.contactTitle": "تواصل معنا",
  "footer.phone": "0097339117226",
  "footer.whatsapp": "0097336370441 (واتساب)",
  "footer.newsEmail": "news@alsiyahiah.com",
  "footer.newsEmailLabel": "التحرير والأخبار",
  "footer.workHours": "أحد - خميس: 8ص - 8م",
  "footer.copyright": "© 2026 صحيفة السياحية - جميع الحقوق محفوظة",
  "footer.privacy": "سياسة الخصوصية",
  "footer.terms": "شروط الاستخدام",
  "footer.policy": "سياسة النشر",
  "footer.ads": "الإعلانات",
  "footer.news.aviation": "أخبار الطيران والمطارات",
  "footer.news.hotels": "الفنادق والمنتجعات",
  "footer.news.destinations": "الوجهات السياحية",
  "footer.news.culture": "السياحة الثقافية",
  "footer.news.family": "الترفيه العائلي",
  "footer.news.tech": "تقنية السفر",
  "footer.news.reports": "تقارير وإحصائيات",
  "footer.special.reports": "تقارير وتحليلات",
  "footer.special.gcc": "دليل السياحة الخليجي",
  "footer.special.events": "المعارض والفعاليات",
  "footer.special.sports": "السياحة الرياضية",
  "footer.special.infographics": "إنفوغرافيك سياحي",
  "footer.special.about": "عن الصحيفة",
  "footer.special.advertise": "الإعلان في صحيفتنا",

  // ── Hero Slider ──
  "hero.readMore": "اقرأ الخبر كاملاً",

  // ── Trending News ──
  "trending.title": "الأكثر قراءةً",
  "trending.viewAll": "عرض كل الأخبار",

  // ── Latest News ──
  "latest.title": "آخر الأخبار",
  "latest.archive": "أرشيف الأخبار",
  "latest.readMore": "اقرأ المزيد",
  "latest.readTime": "للقراءة",

  // ── Featured Destinations ──
  "destinations.title": "أبرز الوجهات السياحية",
  "destinations.subtitle": "آخر أخبار ومستجدات السياحة في المنطقة",
  "destinations.gccGuide": "دليل الخليج",
  "destinations.news": "خبر",

  // ── Hotels Section ──
  "hotels.title": "أخبار الفنادق والمنتجعات",
  "hotels.tab1": "أخبار الفنادق",
  "hotels.tab2": "الافتتاحيات",
  "hotels.tab3": "التقييمات",
  "hotels.more": "المزيد",
  "hotels.viewMore": "عرض المزيد من أخبار الفنادق",
  "hotels.read": "اقرأ",

  // ── Featured Videos ──
  "videos.title": "فيديوهات مميزة",
  "videos.subtitle": "تقارير ومشاهدات حصرية من أبرز الوجهات",
  "videos.playlist": "قائمة التشغيل",
  "videos.viewAll": "كل الفيديوهات",
  "videos.browseAll": "استعرض جميع الفيديوهات",
  "videos.views": "مشاهدة",
  "videos.stat1": "فيديو حصري",
  "videos.stat2": "إجمالي المشاهدات",
  "videos.stat3": "موقع مصوَّر",
  "videos.sectionBadge": "قسم الفيديو",
  "videos.heroLine1": "تقارير سياحية",
  "videos.heroLine2": "مرئية وحصرية",
  "videos.heroSubtitle": "جولات ميدانية، تقارير حصرية، ومشاهدات من أبرز الوجهات السياحية في الخليج والعالم",
  "videos.searchPlaceholder": "ابحث في الفيديوهات...",
  "videos.allVideos": "جميع الفيديوهات",
  "videos.searchResults": "نتائج البحث",
  "videos.countLabel": "{{count}} فيديو",
  "videos.noResults": "لا توجد فيديوهات مطابقة لبحثك",
  "videos.statPublished": "فيديو منشور",
  "videos.statTotalViews": "إجمالي المشاهدات",
  "videos.statContent": "محتوى مرئي",
  "videos.statLocations": "موقع مصوَّر",

  // ── GCC Banner ──
  "gcc.label": "GCC TOURISM GUIDE",
  "gcc.title": "دليل السياحة الخليجي الشامل",
  "gcc.desc": "تغطية إخبارية شاملة لكل ما يتعلق بصناعة السياحة في دول مجلس التعاون الخليجي الست - من الأخبار والتقارير إلى دليل الفنادق والمعالم والمطاعم",
  "gcc.tag1": "أحدث الأخبار",
  "gcc.tag2": "دليل الفنادق",
  "gcc.tag3": "المعالم السياحية",
  "gcc.tag4": "الفعاليات",
  "gcc.cta": "استكشف الدليل الكامل",
  "gcc.news": "خبر",
  "gcc.readCoverage": "اقرأ التغطية ←",

  // ── Opinion / Reports ──
  "opinion.title": "تقارير وتحليلات",
  "opinion.viewAll": "كل التقارير",

  // ── News Categories ──
  "categories.title": "تصفح حسب التصنيف",
  "categories.all": "الكل",
  "categories.news": "خبر",
  "categories.name.aviation": "الطيران والمطارات",
  "categories.name.hotels": "الفنادق والمنتجعات",
  "categories.name.destinations": "الوجهات السياحية",
  "categories.name.culture": "الثقافة والفنون",
  "categories.name.tech": "تقنية السفر",
  "categories.name.sports": "السياحة الرياضية",
  "categories.name.events": "المعارض والفعاليات",
  "categories.name.reports": "تقارير وإحصائيات",
  "categories.name.family": "الترفيه العائلي",
  "categories.name.realestate": "العقارات السياحية",
  "categories.name.eco": "السياحة البيئية",

  // ── Newsletter ──
  "newsletter.badge": "NEWSLETTER",
  "newsletter.title": "ابقَ على اطلاع بأحدث أخبار السياحة",
  "newsletter.desc": "اشترك في نشرتنا الإخبارية الأسبوعية واحصل على أبرز أخبار السفر والسياحة في الخليج والعالم مباشرةً في بريدك الإلكتروني",
  "newsletter.placeholder": "أدخل بريدك الإلكتروني",
  "newsletter.submit": "اشترك مجاناً",
  "newsletter.loading": "...",
  "newsletter.successTitle": "تم الاشتراك بنجاح!",
  "newsletter.successDesc": "ستصلك النشرة الأسبوعية كل أربعاء صباحاً",
  "newsletter.stat1": "+85,000 مشترك",
  "newsletter.stat2": "نشرة أسبوعية كل أربعاء",
  "newsletter.stat3": "لن نشارك بياناتك أبداً",

  // ── Translator ──
  "translator.english": "English",
  "translator.arabic": "العربية",
  "translator.switchToEnglish": "ترجمة الصفحة إلى الإنجليزية",
  "translator.switchToArabic": "العودة إلى العربية",

  // ── Common Static UI ──
  "common.allNews": "كل الأخبار",
  "common.readMore": "اقرأ المزيد",
  "common.viewAll": "عرض الكل",
  "common.view": "عرض",
  "common.featured": "مميز",
  "common.sort": "ترتيب",
  "common.articleCount": "{{count}} خبر",
  "common.like": "إعجاب",
  "common.views": "مشاهدة",
  "common.viewsCount": "{{count}} مشاهدة",
  "common.minutes": "{{count}} دقائق",
  "common.editorialTeam": "فريق التحرير",
  "common.save": "حفظ",
  "common.saved": "محفوظ",
  "common.callNow": "اتصل الآن",
  "common.back": "رجوع",
  "common.read": "اقرأ",
  "common.cancel": "إلغاء",
  "common.optional": "اختياري",
  "common.noResults": "لا توجد نتائج",

  // ── Share UI ──
  "share.label": "شارك:",
  "share.article": "شارك المقال:",
  "share.place": "شارك هذا المكان",
  "share.video": "شارك هذا الفيديو",
  "share.share": "مشاركة",
  "share.copyLink": "نسخ الرابط",
  "share.copy": "نسخ",
  "share.copied": "تم النسخ!",
  "share.likedPrompt": "أعجبك المقال؟ شاركه مع أصدقائك",

  "social.instagram": "إنستغرام",
  "ads.label": "إعلان",

  // ── SEO / Home Static Sections ──
  "seo.home.title": "السياحية - منصة الإعلام السياحي الخليجي | أخبار السياحة والسفر",
  "seo.home.description": "السياحية: المنصة الإعلامية السياحية الأولى في الخليج. تابع أحدث أخبار السياحة والسفر، وجهات خليجية، عروض الفنادق والطيران لعام 2026.",
  "seo.home.keywords": "السياحية, أخبار السياحة, السفر, الخليج, فنادق, وجهات سياحية, عروض سفر, طيران",
  "home.heroFallback.1.category": "سياحة",
  "home.heroFallback.1.title": "مرحباً بكم في السياحية",
  "home.heroFallback.1.description": "منصة الإعلام السياحي الخليجي الأولى لأخبار السياحة والسفر والوجهات الخليجية",
  "home.heroFallback.2.category": "وجهات",
  "home.heroFallback.2.title": "اكتشف أجمل الوجهات السياحية الخليجية",
  "home.heroFallback.2.description": "من دبي إلى مسقط، رحلة عبر أروع المدن والمناطق السياحية في منطقة الخليج العربي",
  "home.heroFallback.3.category": "فنادق",
  "home.heroFallback.3.title": "أفضل الفنادق الفاخرة في الخليج لعام 2026",
  "home.heroFallback.3.description": "دليلك الشامل لأرقى الفنادق والمنتجعات في دول الخليج العربي مع أحدث العروض",
  "home.breakingFallback.1": "مطار دبي يستقبل 92 مليون مسافر في 2025",
  "home.breakingFallback.2": "وزارة السياحة السعودية تُعلن عن 40 وجهة جديدة للسياحة",
  "home.breakingFallback.3": "قطر تستضيف مؤتمر السياحة العالمي 2027",
  "home.breakingFallback.4": "الإمارات تحصد جائزة أفضل وجهة سياحية عربية للعام الثالث على التوالي",
  "home.aviation.title": "أخبار الطيران",
  "home.aviation.subtitle": "آخر مستجدات شركات الطيران والمطارات والوجهات الجديدة",
  "home.travelTips.title": "نصائح السفر",
  "home.travelTips.subtitle": "توجيهات وإرشادات لرحلة سياحية مثالية",

  // ── Destination Static UI ──
  "destinations.newsTitle": "أخبار الوجهات السياحية",
  "destinations.newsSubtitle": "اكتشف أجمل الوجهات السياحية وأحدث المستجدات في الخليج والعالم",
  "destinations.sortMost": "الأكثر أخباراً",
  "destinations.sortLeast": "الأقل أخباراً",
  "destinations.sortAlpha": "أبجدياً",
  "destinations.dragHint": "اسحب يميناً أو يساراً للتنقل",
  "destinations.exploreAll": "استكشف كل الأخبار",
  "cities.dubai": "دبي",
  "cities.riyadh": "الرياض",
  "cities.muscat": "مسقط",
  "cities.doha": "الدوحة",
  "cities.manama": "المنامة",
  "cities.kuwait": "الكويت",
  "countries.uae": "الإمارات",
  "countries.saudi": "السعودية",
  "countries.oman": "عُمان",
  "countries.qatar": "قطر",
  "countries.bahrain": "البحرين",
  "countries.kuwait": "الكويت",

  // ── Other Home Static UI ──
  "hero.exploreContent": "استكشف المحتوى",
  "trending.sortedByViews": "مرتّب حسب المشاهدات",
  "infographics.title": "إنفوغرافيك",
  "infographics.subtitle": "بيانات وإحصائيات بصرية",
  "infographics.browseAll": "استعرض كل الإنفوغرافيك",
  "opinion.articlesTitle": "مقالات الرأي",
  "opinion.articleCount": "{{count}} مقال",
  "opinion.viewAllArticles": "عرض جميع مقالات الرأي",
  "videos.local": "محلي",
  "gcc.stat.hotel": "فندق",
  "gcc.stat.restaurant": "مطعم",
  "gcc.stat.destination": "وجهة",
  "gcc.exploreCountry": "استكشف {{country}}",
  "gcc.stats.countries": "دول خليجية",
  "gcc.stats.hotels": "فندق ومنتجع",
  "gcc.stats.restaurants": "مطعم وكافيه",
  "gcc.stats.destinations": "وجهة سياحية",

  // ── Brand / Common ──
  "brand.name": "السياحية",
  "brand.fullName": "صحيفة السياحية",
  "brand.newspaperName": "صحيفة السياحية",
  "common.news": "الأخبار",
  "common.backHome": "العودة للرئيسية",
  "common.close": "إغلاق",
  "common.previous": "السابق",
  "common.next": "التالي",
  "common.other": "أخرى",
  "common.unavailable": "غير متاح",
  "common.loadingShort": "جارٍ...",
  "common.tryAgainError": "حدث خطأ، يرجى المحاولة مرة أخرى",
  "common.scrollToTop": "العودة إلى أعلى الصفحة",
  "categories.count": "{{count}} خبر",
  "share.whatsapp": "واتساب",
  "share.facebook": "فيسبوك",
  "share.telegram": "تلغرام",
  "share.twitter": "تويتر / X",

  // ── Not Found / Errors ──
  "notFound.title": "الصفحة غير موجودة",
  "notFound.description": "ربما تم حذف الصفحة أو تغيير رابطها. يمكنك العودة للصفحة الرئيسية أو تصفح أقسام الموقع.",
  "notFound.home": "العودة للرئيسية",
  "notFound.search": "البحث في الموقع",
  "errorBoundary.pageTitle": "حدث خطأ غير متوقع",
  "errorBoundary.pageDescription": "نعتذر عن هذا الخلل. يمكنك المحاولة مجدداً أو العودة للصفحة الرئيسية.",
  "errorBoundary.details": "تفاصيل الخطأ",
  "errorBoundary.retry": "إعادة المحاولة",
  "errorBoundary.home": "الصفحة الرئيسية",
  "errorBoundary.sectionTitle": "تعذّر تحميل هذا القسم",
  "errorBoundary.sectionDescription": "حدث خطأ أثناء عرض المحتوى",

  // ── Infographics Page ──
  "seo.infographics.title": "إنفوغرافيك سياحي | السياحية - بيانات وإحصائيات بصرية",
  "seo.infographics.description": "إنفوغرافيك سياحي متخصص يقدم بيانات وإحصائيات بصرية عن السياحة في الخليج والعالم العربي",
  "seo.infographics.keywords": "إنفوغرافيك, سياحة, إحصائيات, بيانات, خليج",
  "infographics.searchPlaceholder": "ابحث في الإنفوغرافيك...",
  "infographics.noResultsTitle": "لا توجد نتائج",
  "infographics.noResultsDescription": "جرّب تغيير الفلتر أو كلمة البحث",
  "infographics.allTitle": "كل الإنفوغرافيك",
  "infographics.shareTitle": "شارك الإنفوغرافيك",
  "infographics.download": "تحميل الإنفوغرافيك",
  "infographics.heroTitle": "إنفوغرافيك سياحي",
  "infographics.heroDescription": "بيانات وإحصائيات بصرية متخصصة في قطاع السياحة والسفر في الخليج والعالم العربي",
  "infographics.stats.infographics": "إنفوغرافيك",
  "infographics.categories.all": "الكل",
  "infographics.categories.statistics": "إحصائيات",
  "infographics.categories.destinations": "وجهات",
  "infographics.categories.hotels": "فنادق",
  "infographics.categories.aviation": "طيران",
  "infographics.categories.seasonal": "موسمي",
  "infographics.categories.religious": "ديني",
  "infographics.categories.eco": "بيئي",

  // ── Contact Page ──
  "seo.contact.title": "اتصل بنا - صحيفة السياحية",
  "seo.contact.description": "تواصل مع فريق صحيفة السياحية. نرحب باستفساراتكم واقتراحاتكم وطلبات التعاون الإعلامي.",
  "seo.contact.keywords": "اتصل بنا, تواصل, صحيفة السياحية, إعلام سياحي, الخليج",
  "contact.title": "اتصل بنا",
  "contact.subtitle": "نرحب بتواصلكم معنا. فريق صحيفة السياحية جاهز للإجابة على استفساراتكم واستقبال اقتراحاتكم وطلبات التعاون.",
  "contact.infoTitle": "معلومات التواصل",
  "contact.email": "البريد الإلكتروني",
  "contact.phone": "الهاتف",
  "contact.whatsapp": "واتساب",
  "contact.address": "العنوان",
  "contact.hours": "ساعات العمل",
  "contact.hoursValue": "الأحد - الخميس: 9:00 ص - 5:00 م",
  "contact.followUs": "تابعنا",
  "contact.noSocial": "لا توجد حسابات مضافة بعد",
  "contact.formTitle": "أرسل رسالتك",
  "contact.formDescription": "املأ النموذج أدناه وسنرد عليك في أقرب وقت ممكن",
  "contact.successTitle": "تم إرسال رسالتك بنجاح",
  "contact.successDescription": "شكراً لتواصلك معنا. سنعود إليك في أقرب وقت.",
  "contact.name": "الاسم الكامل",
  "contact.namePlaceholder": "محمد العتيبي",
  "contact.subject": "الموضوع",
  "contact.subjectPlaceholder": "اختر الموضوع",
  "contact.message": "الرسالة",
  "contact.messagePlaceholder": "اكتب رسالتك هنا...",
  "contact.sending": "جاري الإرسال...",
  "contact.submit": "إرسال الرسالة",
  "contact.submitError": "حدث خطأ أثناء إرسال رسالتك: {{error}}",
  "contact.country": "الدولة",
  "contact.chooseCountry": "اختر الدولة",
  "contact.subjects.inquiry": "استفسار عام",
  "contact.subjects.suggestion": "اقتراح",
  "contact.subjects.advertising": "طلب إعلان",
  "contact.subjects.partnership": "شراكة إعلامية",
  "contact.subjects.complaint": "شكوى",
  "contact.subjects.other": "أخرى",

  // ── Search Page ──
  "seo.search.title": "البحث | السياحية",
  "seo.search.resultsTitle": "نتائج البحث عن \"{{query}}\" | السياحية",
  "seo.search.description": "نتائج البحث عن {{query}} في صحيفة السياحية — أخبار السياحة والسفر والفنادق في الخليج",
  "search.heroLabel": "البحث في السياحية",
  "search.placeholder": "ابحث عن أخبار، وجهات، فنادق...",
  "search.submit": "بحث",
  "search.popularLabel": "بحث شائع:",
  "search.popularSearches": ["دبي", "السياحة السعودية", "فنادق قطر", "العُلا", "طيران الإمارات", "رحلات الخليج"],
  "search.loading": "جاري البحث...",
  "search.resultsPrefix": "وُجد",
  "search.resultsSuffix": "نتيجة لـ",
  "search.noResultsFor": "لا توجد نتائج لـ",
  "search.databaseLoading": "جاري البحث في قاعدة البيانات...",
  "search.noResultsTitle": "لا توجد نتائج",
  "search.noResultsDescription": "لم نجد أي نتائج لـ \"{{query}}\"، جرّب كلمات مختلفة أو تصفح الأقسام أدناه",
  "search.tabs.all": "الكل",
  "search.tabs.articles": "المقالات",
  "search.tabs.videos": "الفيديوهات",
  "search.articlesTitle": "المقالات والأخبار",
  "search.videosTitle": "الفيديوهات",
  "search.viewAllArticles": "عرض كل المقالات ({{count}})",
  "search.viewAllVideos": "عرض كل الفيديوهات ({{count}})",
  "search.noMatchingArticles": "لا توجد مقالات مطابقة",
  "search.noMatchingVideos": "لا توجد فيديوهات مطابقة",
  "search.relatedTags": "الوسوم المرتبطة",
  "search.browseCategories": "تصفح الأقسام",
  "search.tipsTitle": "نصائح البحث",
  "search.tips.destination": "ابحث باسم الوجهة: دبي، الرياض، الدوحة",
  "search.tips.hotel": "ابحث باسم الفندق أو الخط الجوي",
  "search.tips.category": "ابحث بالتصنيف: طيران، فنادق، وجهات",
  "search.tips.languages": "جرّب الاسم بالعربي والإنجليزي",
  "search.statsTitle": "نتائج البحث",
  "search.statsArticles": "مقالات",
  "search.statsVideos": "فيديوهات",
  "search.statsTotal": "الإجمالي",
  "search.startTitle": "ابدأ البحث",
  "search.startDescription": "اكتب ما تبحث عنه في شريط البحث أعلاه",

  // ── Category Page ──
  "seo.category.title": "{{category}} | أخبار السياحة والسفر الخليجي - السياحية",
  "seo.category.description": "تابع أحدث أخبار {{category}} في الخليج العربي. {{count}} خبر ومقال متاح. السياحية - المنصة الإعلامية السياحية الأولى خليجياً.",
  "seo.category.keywords": "{{category}}, سياحة خليجية, أخبار السفر, {{slug}}",
  "seo.category.jsonName": "{{category}} - السياحية",
  "seo.category.jsonDescription": "مجموعة مقالات وأخبار {{category}} في الخليج العربي",
  "category.searchPlaceholder": "ابحث في هذا القسم...",
  "category.sortLatest": "الأحدث",
  "category.sortPopular": "الأكثر قراءة",
  "category.noResults": "لا توجد نتائج لبحثك",
  "category.availableCount": "{{count}} خبر ومقال متاح في هذا القسم",
  "category.tryVisiting": "جرّب زيارة",
  "category.toSeeAllNews": "لرؤية كل الأخبار",
  "category.pinned": "مثبت",
  "category.progress": "تم عرض {{shown}} من {{total}} مقال",
  "category.loadingMore": "جاري التحميل...",
  "category.loadMore": "تحميل المزيد",
  "category.allShown": "تم عرض جميع المقالات",

  // ── Videos Page SEO / labels ──
  "seo.videos.title": "فيديوهات السياحية — أحدث تقارير ومشاهدات السياحة الخليجية",
  "seo.videos.description": "تابع أحدث فيديوهات صحيفة السياحية: تقارير ميدانية، جولات حصرية، ومشاهدات من أبرز الوجهات السياحية الخليجية والعالمية.",
  "seo.videos.keywords": "فيديوهات سياحة, تقارير سياحية, جولات فيديو, الخليج, سفر",
  "videos.heroAlt": "فيديوهات السياحية",
  "videos.featuredTitle": "فيديوهات مميزة",

  // ── PDF Edition ──
  "pdf.shareEdition": "شارك العدد",
  "pdf.subscribe.title": "اشترك في إشعارات العدد اليومي",
  "pdf.subscribe.description": "احصل على إشعار فوري بالبريد الإلكتروني عند صدور كل عدد جديد من صحيفة السياحية",
  "pdf.subscribe.successTitle": "تم الاشتراك بنجاح!",
  "pdf.subscribe.successDescription": "ستصلك إشعارات عند نشر كل عدد جديد",
  "pdf.subscribe.existsTitle": "أنت مشترك بالفعل!",
  "pdf.subscribe.existsDescription": "هذا البريد الإلكتروني مسجّل مسبقاً في قائمة الإشعارات",
  "pdf.subscribe.namePlaceholder": "اسمك (اختياري)",
  "pdf.subscribe.submit": "اشترك الآن",
  "pdf.digitalEdition": "النسخة الرقمية",
  "pdf.heroDescription": "اقرأ العدد اليومي لصحيفة السياحية بصيغة PDF — متاح للتصفح والتحميل مجاناً",
  "pdf.latestEdition": "أحدث إصدار",
  "pdf.publishedToday": "صدر اليوم",
  "pdf.editionDescription": "العدد اليومي لصحيفة السياحية — أبرز أخبار السفر والسياحة في الخليج والعالم",
  "pdf.reads": "قراءة",
  "pdf.downloads": "تحميل",
  "pdf.readNow": "قراءة العدد الآن",
  "pdf.downloadPdf": "تحميل PDF",
  "pdf.noEditionsTitle": "لا توجد أعداد منشورة حتى الآن",
  "pdf.noEditionsDescription": "سيتم نشر العدد اليومي قريباً",
  "pdf.archiveTitle": "أرشيف الصحيفة",
  "pdf.archiveDescription": "تصفح جميع الأعداد السابقة لصحيفة السياحية",
  "pdf.visitArchive": "زيارة الأرشيف",
  "pdf.previousEditions": "الأعداد السابقة",
  "pdf.editionCount": "{{count}} عدد",
  "pdf.read": "قراءة",

  // ── Article Page ──
  "seo.article.title": "{{title}} | السياحية",
  "seo.article.keywords": "{{category}}, {{tags}}, أخبار السياحة, السفر الخليجي",
  "seo.article.notFoundTitle": "مقال غير موجود | السياحية",
  "seo.article.notFoundDescription": "المقال المطلوب غير موجود في صحيفة السياحية",
  "article.notFoundTitle": "المقال غير موجود",
  "article.notFoundDescription": "ربما تم حذف المقال أو تغيير رابطه",
  "article.likesCount": "{{count}} إعجاب",
  "article.fallbackDetailsTitle": "تفاصيل الخبر",
  "article.fallbackDetailsParagraph": "في تطور لافت يُعزز مكانة المنطقة على الخريطة السياحية العالمية، تأتي هذه الأخبار في وقت تشهد فيه صناعة السياحة والسفر في منطقة الخليج نمواً غير مسبوق، مدفوعةً بالاستثمارات الضخمة ورؤى التنويع الاقتصادي.",
  "article.fallbackQuote": "هذه الأخبار تعكس التوجه الاستراتيجي لقطاع السياحة الذي يرى فيه الجميع ركيزةً أساسية للتنويع الاقتصادي وخلق فرص العمل في المنطقة.",
  "article.quoteAttribution": "— {{author}}، {{title}}",
  "article.fallbackContextTitle": "السياق والأثر",
  "article.fallbackContextParagraph": "يأتي هذا التطور في سياق موجة النمو القياسي التي يشهدها القطاع السياحي الخليجي، إذ تواصل دول المنطقة تنفيذ مشاريع طموحة تهدف إلى تنويع مصادر الدخل وتقليل الاعتماد على النفط.",
  "article.fallbackParagraph": "ويرى المحللون أن الاستثمارات الضخمة في البنية التحتية السياحية ستُعطي ثمارها على المدى المتوسط، مع توقعات بأن تتجاوز الإيرادات السياحية لدول الخليج مجتمعةً 150 مليار دولار قبل حلول عام 2030.",
  "article.tags": "الوسوم",
  "article.relatedNews": "أخبار ذات صلة",
  "article.authorLabel": "كاتب المقال",
  "article.authorBio": "صحفي متخصص في أخبار السياحة والسفر بخبرة واسعة في تغطية أبرز أحداث القطاع في منطقة الخليج والعالم. يكتب بانتظام في صحيفة السياحية منذ تأسيسها.",
  "article.viewsLabel": "مشاهدات هذا المقال",
  "article.advertiseHere": "أعلن في هذا الموضع",
  "article.trendingNow": "الأكثر قراءةً الآن",
  "article.readAlso": "اقرأ أيضاً",
  "article.articleImage": "صورة المقال",
  "article.articleImages": "صور المقال",
  "article.imageCount": "{{count}} صورة",
  "article.articleVideo": "فيديو المقال",
  "article.articleVideos": "فيديوهات المقال",
  "article.imageNumber": "الصورة {{number}}",
  "article.lightboxHint": "اضغط في أي مكان أو Esc للإغلاق",
  "newsletter.articleDescription": "احصل على أهم أخبار السياحة أسبوعياً",

  // ── About Page ──
  "seo.about.title": "عن صحيفة السياحية | منصة الإعلام السياحي الخليجي من المنامة منذ 2011",
  "seo.about.description": "تعرف على صحيفة السياحية: المنصة الإعلامية السياحية الأولى في الخليج منذ 2011، مقرها المنامة، مملكة البحرين. فريق من 35 صحفياً متخصصاً يغطي أخبار السياحة والسفر في 6 دول خليجية.",
  "seo.about.keywords": "عن السياحية, صحيفة سياحية خليجية, إعلام سياحي, فريق تحرير سياحي",
  "about.seoJsonName": "عن صحيفة السياحية",
  "about.seoJsonDescription": "منصة إعلامية سياحية متكاملة للخليج العربي تأسست عام 2011",
  "about.heroImageAlt": "عن صحيفة السياحية",
  "about.badge": "عن الصحيفة · Since {{year}}",
  "about.heroTitle": "صحيفة السياحية",
  "about.heroSubtitle": "منصة الإعلام السياحي المميزة في الخليج العربي والعالم",
  "about.numbers.readers": "قارئ شهري",
  "about.numbers.subscribers": "مشترك في النشرة",
  "about.numbers.experience": "سنة من الخبرة",
  "about.numbers.journalists": "صحفي ومحرر",
  "about.numbers.countries": "دول خليجية مغطاة",
  "about.numbers.advertisers": "معلن موثوق",
  "about.whoTitle": "من نحن؟",
  "about.content.description1": "صحيفة السياحية هي منصة إعلامية إلكترونية يومية متخصصة في أخبار السفر والسياحة في منطقة الخليج العربي والعالم. تأسست عام 2011 في المنامة، مملكة البحرين، بهدف تقديم تغطية إعلامية احترافية وموضوعية لكل ما يتعلق بصناعة السياحة، من أخبار الطيران والفنادق إلى التقارير والتحليلات الاقتصادية.",
  "about.content.description2": "نؤمن بأن الإعلام السياحي المتخصص يلعب دوراً محورياً في تطوير القطاع ودعم صانعي القرار والمستثمرين والمسافرين على حد سواء. لذلك نحرص على تقديم محتوى دقيق وموثوق يعكس المشهد السياحي الحقيقي في المنطقة.",
  "about.content.description3": "يعمل في صحيفة السياحية فريق من 35 صحفياً ومحرراً متخصصاً يغطون الأحداث السياحية الكبرى في الخليج والعالم، مع حضور دائم في المؤتمرات والمعارض السياحية الدولية، انطلاقاً من مقرها الرئيسي في المنامة، مملكة البحرين.",
  "about.content.vision": "أن نكون المرجع الإعلامي الأول والأكثر موثوقية لصناعة السياحة في منطقة الخليج والوطن العربي.",
  "about.content.mission": "تقديم صحافة سياحية متخصصة وموضوعية تخدم القراء والمهنيين وتُسهم في تطوير القطاع السياحي.",
  "about.content.values": "الموضوعية والمصداقية والتخصص والاستقلالية التحريرية في كل ما ننشره.",
  "about.images.editorial": "فريق التحرير",
  "about.images.events": "تغطية الفعاليات",
  "about.images.newsroom": "غرفة التحرير",
  "about.images.awards": "الجوائز",
  "about.identityTitle": "هويتنا المؤسسية",
  "about.visionTitle": "رؤيتنا",
  "about.missionTitle": "رسالتنا",
  "about.valuesTitle": "قيمنا",
  "about.teamTitle": "فريق التحرير",
  "about.teamDescription": "نخبة من الصحفيين المتخصصين في السياحة والسفر بخبرات ممتدة في الإعلام الخليجي",
  "about.journeyTitle": "مسيرتنا عبر السنوات",
  "about.awardsTitle": "جوائزنا وإنجازاتنا",
  "about.ctaTitle": "هل تريد العمل معنا أو الإعلان في صحيفتنا؟",
  "about.ctaDescription": "نرحب بالمحررين والمراسلين المتخصصين، ونوفر حلولاً إعلانية للشركات السياحية",
  "about.advertiseCta": "أعلن في صحيفتنا",
  "about.awards.1.year": "2024",
  "about.awards.1.title": "أفضل منصة إعلامية سياحية",
  "about.awards.1.body": "جائزة الإعلام العربي — القاهرة",
  "about.awards.2.year": "2023",
  "about.awards.2.title": "أفضل تغطية حدث سياحي",
  "about.awards.2.body": "مؤتمر السياحة الخليجي — أبوظبي",
  "about.awards.3.year": "2022",
  "about.awards.3.title": "الصحافة الاستقصائية",
  "about.awards.3.body": "جائزة الصحافة المتخصصة — بيروت",
  "about.awards.4.year": "2021",
  "about.awards.4.title": "أفضل موقع سياحي خليجي",
  "about.awards.4.body": "جوائز رواد الأعمال الرقميين — المنامة، البحرين",
  "about.team.1.name": "د. محمد الرشيد",
  "about.team.1.role": "رئيس التحرير",
  "about.team.1.bio": "دكتوراه في الإعلام السياحي من جامعة الملك عبدالعزيز. يقود الصحيفة منذ تأسيسها عام 2011 بخبرة 20 عاماً في الصحافة المتخصصة.",
  "about.team.2.name": "ريم الفهد",
  "about.team.2.role": "مديرة التحرير",
  "about.team.2.bio": "صحفية متخصصة بخبرة 15 عاماً في تغطية أخبار السياحة والفنادق الفاخرة. فازت بجائزة الصحافة السياحية العربية ثلاث مرات.",
  "about.team.3.name": "أحمد الزهراني",
  "about.team.3.role": "محرر أخبار الطيران",
  "about.team.3.bio": "متخصص في أخبار قطاع الطيران والمطارات. يتابع كل جديد من المؤتمرات والمعارض الدولية مثل IATA وATM.",
  "about.team.4.name": "رنا القحطاني",
  "about.team.4.role": "محررة الفنادق والضيافة",
  "about.team.4.bio": "ناقدة ضيافة متخصصة تُراجع أرقى الفنادق في المنطقة وتقدم تقييمات موضوعية يثق بها القراء والمستثمرون.",
  "about.team.5.name": "فيصل الدوسري",
  "about.team.5.role": "محرر السياحة الثقافية",
  "about.team.5.bio": "متخصص في التراث والسياحة الثقافية. يغطي المهرجانات والمواقع الأثرية في الجزيرة العربية وخارجها.",
  "about.team.6.name": "سامي الحربي",
  "about.team.6.role": "محرر تقنية السفر",
  "about.team.6.bio": "خبير في تقنيات السياحة والسفر الذكي. يواكب أحدث التطبيقات والحلول الرقمية التي تُحوّل تجربة المسافر.",
  "about.team.7.name": "نورا العتيبي",
  "about.team.7.role": "مراسلة أوروبا",
  "about.team.7.bio": "مراسلة ميدانية مقيمة في لندن، تغطي أبرز المعارض السياحية الأوروبية وتقارير الوجهات الدولية.",
  "about.team.8.name": "خالد المنصور",
  "about.team.8.role": "محرر الاقتصاد السياحي",
  "about.team.8.bio": "محلل اقتصادي متخصص في قطاع السياحة، يُعدّ تقارير الاستثمار السياحي ومتابعة مؤشرات الأداء الفندقي.",
  "about.milestones.1.title": "التأسيس",
  "about.milestones.1.desc": "انطلاق صحيفة السياحية الإلكترونية كأول منبر إعلامي متخصص في أخبار السفر والسياحة الخليجية",
  "about.milestones.2.title": "أول جائزة صحفية",
  "about.milestones.2.desc": "حصلت الصحيفة على جائزة أفضل منصة إعلامية سياحية في المؤتمر السياحي الخليجي بالرياض",
  "about.milestones.3.title": "أول تغطية دولية",
  "about.milestones.3.desc": "فريق متكامل لتغطية معرض سوق السفر العربي ATM في دبي للمرة الأولى بتمثيل رسمي",
  "about.milestones.4.title": "النشرة الإخبارية",
  "about.milestones.4.desc": "إطلاق النشرة الإخبارية الأسبوعية التي وصل عدد مشتركيها إلى 50 ألف خلال عام واحد",
  "about.milestones.5.title": "شبكة مراسلين",
  "about.milestones.5.desc": "توسيع شبكة المراسلين لتشمل 12 دولة وفتح مكاتب إقليمية في الرياض والقاهرة إضافةً إلى المقر الرئيسي في المنامة",
  "about.milestones.6.title": "توسع رقمي",
  "about.milestones.6.desc": "إطلاق التطبيق الذكي وحسابات التواصل الاجتماعي التي تجاوزت 500 ألف متابع في أول عام",
  "about.milestones.7.title": "مليون قارئ",
  "about.milestones.7.desc": "تخطي حاجز المليون قارئ شهري وإطلاق دليل السياحة الخليجي التفاعلي",
  "about.milestones.8.title": "منصة شاملة",
  "about.milestones.8.desc": "إعادة إطلاق المنصة بهويتها الجديدة من المنامة، مملكة البحرين، مع خدمات إعلامية متكاملة للقطاع السياحي الخليجي",

  // ── Advertising Page ──
  "seo.advertising.title": "أعلن في السياحية | حلول إعلانية سياحية خليجية | 2.5M+ قارئ",
  "seo.advertising.description": "أعلن في صحيفة السياحية واستهدف أكثر من 2.5 مليون قارئ شهري مهتم بالسياحة والسفر في الخليج. باقات إعلانية متنوعة: بانر، مقالات ممولة، نشرة إخبارية.",
  "seo.advertising.keywords": "إعلان سياحي, تسويق سياحي, إعلانات خليجية, باقات إعلانية, منصة سياحية",
  "advertising.schemaName": "خدمات الإعلان في صحيفة السياحية",
  "advertising.schemaDescription": "خدمات إعلانية متخصصة في قطاع السياحة والسفر الخليجي",
  "advertising.heroAlt": "الإعلان في السياحية",
  "advertising.heroTitle": "أعلن في صحيفة السياحية",
  "advertising.heroDescription": "استهدف ملايين القراء المهتمين بالسفر والسياحة في منطقة الخليج العربي عبر منصتنا الإعلامية الرائدة",
  "advertising.viewPackages": "عرض الباقات",
  "advertising.stats.readers": "قارئ شهري",
  "advertising.stats.subscribers": "مشترك في النشرة",
  "advertising.stats.countries": "دول خليجية",
  "advertising.stats.satisfaction": "رضا المعلنين",
  "advertising.credentials.award": "أفضل منصة إعلامية سياحية خليجية 2025",
  "advertising.credentials.member": "عضو في اتحاد الصحافة العربية",
  "advertising.credentials.coverage": "تغطية في 40+ دولة حول العالم",
  "advertising.credentials.team": "فريق تحريري من 35 صحفياً متخصصاً",
  "advertising.formatsTitle": "خيارات الإعلان المتاحة",
  "advertising.formatsDescription": "نوفر حلولاً إعلامية متنوعة تناسب كل الأهداف التسويقية والميزانيات",
  "advertising.adFormats.banner.title": "إعلانات البانر",
  "advertising.adFormats.banner.description": "إعلانات مرئية في أبرز مواضع الصفحات بأحجام IAB القياسية",
  "advertising.adFormats.banner.details": "728×90 | 300×250 | 160×600 | 320×50",
  "advertising.adFormats.sponsored.title": "المقالات الممولة",
  "advertising.adFormats.sponsored.description": "محتوى صحفي احترافي مدمج في سياق الأخبار للوصول لأعلى تفاعل",
  "advertising.adFormats.sponsored.details": "يُكتب بقلم فريق تحريري متخصص",
  "advertising.adFormats.newsletter.title": "النشرة الإخبارية",
  "advertising.adFormats.newsletter.description": "إعلانات مدمجة في النشرة الأسبوعية التي تصل لأكثر من 85,000 مشترك",
  "advertising.adFormats.newsletter.details": "نشرة أسبوعية — أربعاء كل أسبوع",
  "advertising.adFormats.events.title": "تغطية الفعاليات",
  "advertising.adFormats.events.description": "تغطية إعلامية شاملة لفعالياتك السياحية مع صور وتقارير احترافية",
  "advertising.adFormats.events.details": "مؤتمرات | معارض | افتتاحيات",
  "advertising.adFormats.social.title": "التواصل الاجتماعي",
  "advertising.adFormats.social.description": "ترويج عبر حساباتنا على منصات التواصل الاجتماعي بمتابعين نشطين",
  "advertising.adFormats.social.details": "+500K متابع عبر جميع المنصات",
  "advertising.adFormats.editorial.title": "الظهور التحريري",
  "advertising.adFormats.editorial.description": "إدراج مؤسستك ضمن التقارير والمراجعات الصحفية المتخصصة",
  "advertising.adFormats.editorial.details": "تقييمات فنادق | تقارير وجهات",
  "advertising.pricingTitle": "باقات الإعلان",
  "advertising.pricingDescription": "أسعار شفافة وعادلة مع ضمان الوصول الفعلي لجمهورك المستهدف",
  "advertising.mostRequested": "الأكثر طلباً",
  "advertising.impressions": "ظهور",
  "advertising.packageCta": "اشترك في هذه الباقة",
  "advertising.pricingNote": "جميع الأسعار قابلة للتفاوض للعقود السنوية · تسري ضريبة القيمة المضافة",
  "advertising.whyImageAlt": "لماذا تعلن في السياحية",
  "advertising.whyTitle": "لماذا تختار الإعلان في صحيفة السياحية؟",
  "advertising.whyDescription": "نحن المنبر الإعلامي الأول المتخصص في السياحة والسفر في منطقة الخليج، ونصل إلى جمهور متخصص ومهتم فعلياً بالقطاع السياحي.",
  "advertising.why.audience.title": "جمهور متخصص ومؤهل",
  "advertising.why.audience.desc": "قراؤنا من المهتمين بالسفر والسياحة وصانعي القرار في القطاع",
  "advertising.why.coverage.title": "تغطية جغرافية خليجية واسعة",
  "advertising.why.coverage.desc": "حضور قوي في الإمارات، السعودية، قطر، الكويت، البحرين وعُمان",
  "advertising.why.results.title": "نتائج قابلة للقياس",
  "advertising.why.results.desc": "تقارير تفصيلية دقيقة لكل حملة: مشاهدات، نقرات، ومعدلات التفاعل",
  "advertising.why.credibility.title": "مصداقية إعلامية راسخة",
  "advertising.why.credibility.desc": "15+ عاماً في الصحافة السياحية المتخصصة تمنح إعلانك مصداقية حقيقية",
  "advertising.trustedTitle": "يثق بنا أكثر من 200 معلن",
  "advertising.faqTitle": "أسئلة شائعة",
  "advertising.faq.custom.q": "هل يمكن تخصيص الباقة حسب ميزانيتي؟",
  "advertising.faq.custom.a": "نعم، فريقنا الإعلاني يعمل معك لتصميم خطة مرنة تناسب ميزانيتك وأهدافك التسويقية.",
  "advertising.faq.launch.q": "كم يستغرق تنفيذ الحملة الإعلانية؟",
  "advertising.faq.launch.a": "عادةً تبدأ الحملة خلال 48 ساعة من تأكيد الطلب وإتمام عملية الدفع.",
  "advertising.faq.annual.q": "هل تتوفر عروض للعقود السنوية؟",
  "advertising.faq.annual.a": "نعم، نقدم خصومات تصل إلى 25% للعقود السنوية، تواصل معنا للاستفسار.",
  "advertising.faq.payment.q": "ما هي طرق الدفع المتاحة؟",
  "advertising.faq.payment.a": "نقبل التحويل البنكي، بطاقات الائتمان، وأوامر الشراء للشركات الكبرى.",
  "advertising.contactTitle": "تواصل مع قسم الإعلانات",
  "advertising.contactDescription": "فريقنا الإعلامي المتخصص جاهز لتصميم خطة إعلانية مخصصة تناسب هدفك التسويقي وميزانيتك.",
  "advertising.adPhone": "هاتف القسم الإعلاني",
  "advertising.hoursValue": "الأحد — الخميس: 9ص — 6م",
  "advertising.consultantTitle": "تحدث مع مستشار إعلاني الآن",
  "advertising.consultantDescription": "استشارة مجانية خلال 24 ساعة",
  "advertising.startNow": "ابدأ الآن",
  "advertising.thanksTitle": "شكراً لتواصلك معنا!",
  "advertising.thanksDescription": "سيقوم مدير الإعلانات بالتواصل معك خلال 24 ساعة عمل",
  "advertising.submitError": "تعذر إرسال طلبك. يرجى المحاولة مرة أخرى.",
  "advertising.formTitle": "أرسل طلب الإعلان",
  "advertising.formDescription": "يصلنا طلبك مباشرة ونتواصل معك خلال 24 ساعة",
  "advertising.companyInfo": "معلومات الشركة",
  "advertising.companyName": "اسم الشركة / المؤسسة",
  "advertising.companyPlaceholder": "اسم شركتك",
  "advertising.phoneWhatsapp": "رقم الهاتف / واتساب",
  "advertising.website": "الموقع الإلكتروني",
  "advertising.campaignDetails": "تفاصيل الحملة",
  "advertising.adType": "نوع الإعلان المطلوب",
  "advertising.chooseType": "اختر النوع",
  "advertising.types.banner": "إعلان بانر",
  "advertising.types.sponsored": "مقال صحفي ممول",
  "advertising.types.newsletter": "نشرة إخبارية",
  "advertising.types.events": "تغطية فعاليات",
  "advertising.types.social": "تواصل اجتماعي",
  "advertising.types.package": "باقة شاملة",
  "advertising.packageInterested": "الباقة المهتم بها",
  "advertising.choosePackage": "اختر الباقة (اختياري)",
  "advertising.budget": "الميزانية الشهرية المتوقعة",
  "advertising.chooseRange": "اختر النطاق",
  "advertising.budgets.under": "أقل من 200 د.ب",
  "advertising.budgets.low": "200 - 500 د.ب",
  "advertising.budgets.mid": "500 - 1,500 د.ب",
  "advertising.budgets.high": "أكثر من 1,500 د.ب",
  "advertising.duration": "مدة الحملة المطلوبة",
  "advertising.chooseDuration": "اختر المدة",
  "advertising.durations.week": "أسبوع",
  "advertising.durations.twoWeeks": "أسبوعان",
  "advertising.durations.month": "شهر",
  "advertising.durations.twoMonths": "شهران",
  "advertising.durations.threeMonths": "3 أشهر",
  "advertising.durations.sixMonths": "6 أشهر",
  "advertising.durations.year": "سنة كاملة",
  "advertising.targetAudience": "الجمهور المستهدف",
  "advertising.targetPlaceholder": "مثال: عائلات خليجية، مسافرو الأعمال، سياح أوروبيون...",
  "advertising.extraDetails": "تفاصيل إضافية عن الحملة",
  "advertising.messagePlaceholder": "أخبرنا عن هدفك الإعلاني وأي تفاصيل تريد إيصالها...",
  "advertising.submit": "إرسال الطلب الإعلاني",
  "advertising.finalTitle": "ابدأ تواصلك مع قرّاء السياحية",
  "advertising.finalDescription": "انضم لأكثر من 200 شركة سياحية تعلن في صحيفتنا للوصول لجمهورهم المتخصص",
  "advertising.contactNow": "تواصل معنا الآن",

  // ── GCC Guide Page ──
  "seo.gccGuide.title": "دليل السياحة الخليجي | فنادق ومطاعم ومعالم {{country}} - السياحية",
  "seo.gccGuide.description": "دليل سياحي شامل لدول الخليج: أفضل الفنادق والمطاعم والمعالم السياحية في {{country}}. اكتشف وجهات سياحية خليجية مختارة.",
  "seo.gccGuide.keywords": "دليل سياحة خليجي, فنادق الخليج, مطاعم خليجية, معالم سياحية, سياحة الإمارات, سياحة السعودية",
  "gccGuide.gulf": "الخليج",
  "gccGuide.allCountries": "الإمارات والسعودية وقطر والكويت والبحرين وعُمان",
  "gccGuide.schemaName": "دليل السياحة الخليجي - السياحية",
  "gccGuide.schemaDescription": "دليل سياحي شامل لدول الخليج العربي يضم أفضل الفنادق والمطاعم والمعالم السياحية",
  "gccGuide.types.hotels": "الفنادق",
  "gccGuide.types.restaurants": "المطاعم",
  "gccGuide.types.attractions": "المعالم",
  "gccGuide.types.tripPlanner": "صمم رحلتك",
  "gccGuide.typeSingular.hotel": "فندق",
  "gccGuide.typeSingular.restaurant": "مطعم",
  "gccGuide.typeSingular.attraction": "معلم",
  "gccGuide.chooseCountry": "اختر الدولة",
  "gccGuide.highlights": "أبرز المعالم",
  "gccGuide.budget": "الميزانية",
  "gccGuide.budgetFilters.0": "الكل",
  "gccGuide.budgetFilters.1": "اقتصادي",
  "gccGuide.budgetFilters.2": "متوسط",
  "gccGuide.budgetFilters.3": "فاخر",
  "gccGuide.travellerType": "نوع المسافر",
  "gccGuide.travellerFilters.0": "الكل",
  "gccGuide.travellerFilters.1": "عائلي",
  "gccGuide.travellerFilters.2": "رومانسي",
  "gccGuide.travellerFilters.3": "منفرد",
  "gccGuide.travellerFilters.4": "مجموعات",
  "gccGuide.search": "البحث",
  "gccGuide.searchPlaceholder": "ابحث عن فندق أو مطعم...",
  "gccGuide.planTripIn": "صمم رحلتك في {{country}}",
  "gccGuide.planTripDescription": "خطط لرحلتك يوماً بيوم، اختر الفنادق والمطاعم والمعالم، وصدّر خطتك كملف PDF جاهز للطباعة.",
  "gccGuide.startPlanning": "ابدأ التخطيط الآن",
  "gccGuide.noResultsTitle": "لا توجد نتائج",
  "gccGuide.noResultsDescription": "جرّب تغيير الفلاتر أو البحث بكلمة مختلفة",
  "gccGuide.resetFilters": "إعادة ضبط الفلاتر",
  "gccGuide.inDevelopment": "قيد التطوير",
  "gccGuide.comingSoon": "سيتم إضافة قوائم {{country}} قريباً",
  "gccGuide.locationMap": "الموقع الجغرافي",
  "gccGuide.mapTitle": "خريطة {{country}}",
  "gccGuide.exploreOtherCountries": "استكشف دول الخليج الأخرى",
  "gccGuide.backToGuide": "العودة لدليل الخليج",
  "seo.gccListing.title": "{{name}} | {{type}} {{country}} - السياحية",
  "seo.gccListing.defaultTitle": "تفاصيل المكان - السياحية",
  "seo.gccListing.description": "{{name}} في {{location}}. تقييم {{rating}}/5 من {{reviews}} زائر. {{price}}. اكتشف التفاصيل والصور والتقييمات.",
  "seo.gccListing.keywords": "{{name}}, {{location}}, {{category}}, دليل الخليج",
  "gccGuide.countryNews.title": "أخبار {{country}}",
  "gccGuide.countryNews.newsCount": "{{count}} خبر",
  "gccGuide.countryNews.categories.all": "الكل",
  "gccGuide.countryNews.categories.aviation": "الطيران",
  "gccGuide.countryNews.categories.hotels": "الفنادق",
  "gccGuide.countryNews.categories.destinations": "الوجهات",
  "gccGuide.countryNews.categories.events": "الفعاليات",
  "gccGuide.countryNews.categories.reports": "تقارير",
  "gccGuide.countryNews.noCategoryNews": "لا توجد أخبار في هذا التصنيف",
  "gccGuide.countryNews.noMoreNews": "لا توجد أخبار إضافية",
  "gccGuide.countryNews.stats.published": "خبر منشور",
  "gccGuide.countryNews.stats.views": "إجمالي المشاهدات",
  "gccGuide.countryNews.stats.featured": "خبر مميز",
  "gccGuide.listing.notFoundTitle": "المكان غير موجود",
  "gccGuide.listing.notFoundDescription": "لم نتمكن من العثور على هذا المكان",
  "gccGuide.listing.selected": "مختار",
  "gccGuide.listing.featured": "مميز",
  "gccGuide.listing.reviewsCount": "{{count}} تقييم",
  "gccGuide.listing.tabs.overview": "نظرة عامة",
  "gccGuide.listing.tabs.gallery": "الصور",
  "gccGuide.listing.tabs.reviews": "التقييمات",
  "gccGuide.listing.tabs.map": "الموقع",
  "gccGuide.listing.aboutTitle": "عن المكان",
  "gccGuide.listing.fallbackAbout.1": "من أبرز الوجهات السياحية في {{location}}، حيث يجمع بين الأصالة والحداثة في تجربة فريدة. يتميز المكان بموقعه وخدماته التي تلبي احتياجات مختلف الزوار.",
  "gccGuide.listing.fallbackAbout.2": "يركز الفريق على تقديم أفضل تجربة ممكنة للزوار مع الاهتمام بالتفاصيل. يُصنَّف المكان ضمن الوجهات الأعلى تقييماً بدرجة تتجاوز {{rating}} من 5 نجوم.",
  "gccGuide.listing.amenitiesTitle": "المرافق والخدمات",
  "gccGuide.listing.openingHours": "ساعات العمل",
  "gccGuide.listing.days.sunThu": "الأحد - الخميس",
  "gccGuide.listing.days.friday": "الجمعة",
  "gccGuide.listing.days.saturday": "السبت",
  "gccGuide.listing.defaultHours.sunThu": "9:00 ص - 11:00 م",
  "gccGuide.listing.defaultHours.friday": "2:00 م - 12:00 ص",
  "gccGuide.listing.defaultHours.saturday": "10:00 ص - 12:00 ص",
  "gccGuide.listing.galleryTitle": "معرض الصور",
  "gccGuide.listing.photosCount": "{{count}} صورة",
  "gccGuide.listing.mapTitle": "الموقع على الخريطة",
  "gccGuide.listing.mapIframeTitle": "موقع {{name}}",
  "gccGuide.listing.openInGoogleMaps": "فتح في خرائط جوجل",
  "gccGuide.listing.price": "السعر",
  "gccGuide.listing.rating": "التقييم",
  "gccGuide.listing.reviewCount": "عدد التقييمات",
  "gccGuide.listing.location": "الموقع",
  "gccGuide.listing.category": "الفئة",
  "gccGuide.listing.website": "الموقع الإلكتروني",
  "gccGuide.listing.viewOnMap": "عرض على الخريطة",
  "gccGuide.listing.country": "الدولة",
  "gccGuide.listing.similarPlaces": "أماكن مشابهة",
  "gccGuide.listing.amenities.freeWifi": "واي فاي مجاني",
  "gccGuide.listing.amenities.pool": "مسبح",
  "gccGuide.listing.amenities.restaurant": "مطعم",
  "gccGuide.listing.amenities.gym": "صالة رياضية",
  "gccGuide.listing.amenities.roomService": "خدمة الغرف",
  "gccGuide.listing.amenities.parking": "موقف سيارات",
  "gccGuide.listing.amenities.spa": "سبا",
  "gccGuide.listing.amenities.businessCenter": "مركز أعمال",
  "gccGuide.listing.amenities.reservations": "حجز مسبق",
  "gccGuide.listing.amenities.takeaway": "طلبات خارجية",
  "gccGuide.listing.amenities.delivery": "توصيل",
  "gccGuide.listing.amenities.vegetarianMenu": "قائمة نباتية",
  "gccGuide.listing.amenities.familyFriendly": "مناسب للعائلات",
  "gccGuide.listing.amenities.liveMusic": "موسيقى حية",
  "gccGuide.listing.amenities.tourGuide": "مرشد سياحي",
  "gccGuide.listing.amenities.giftShop": "متجر هدايا",
  "gccGuide.listing.amenities.onsiteRestaurant": "مطعم داخلي",
  "gccGuide.listing.amenities.kidFriendly": "مناسب للأطفال",
  "gccGuide.listing.amenities.accessible": "ذوو الاحتياجات الخاصة",
  "gccGuide.gallery.mainImageAlt": "{{name}} - صورة رئيسية",
  "gccGuide.gallery.imageAlt": "{{name}} - صورة {{number}}",
  "gccGuide.reviews.title": "آراء الزوار",
  "gccGuide.reviews.rating.1": "سيء",
  "gccGuide.reviews.rating.2": "مقبول",
  "gccGuide.reviews.rating.3": "جيد",
  "gccGuide.reviews.rating.4": "جيد جداً",
  "gccGuide.reviews.rating.5": "ممتاز",
  "gccGuide.reviews.scores.location": "الموقع",
  "gccGuide.reviews.scores.cleanliness": "النظافة",
  "gccGuide.reviews.scores.service": "الخدمة",
  "gccGuide.reviews.scores.value": "القيمة",
  "gccGuide.reviews.helpful": "مفيد ({{count}})",
  "gccGuide.reviews.loadMore": "عرض المزيد من التقييمات",
  "gccGuide.reviews.1.author": "محمد العمري",
  "gccGuide.reviews.1.date": "مارس 2025",
  "gccGuide.reviews.1.text": "تجربة استثنائية في {{name}}! الخدمة كانت على أعلى مستوى والموظفون متعاونون جداً. المكان نظيف ومرتب بشكل رائع. سأعود بالتأكيد وأنصح به كل من يزور المنطقة.",
  "gccGuide.reviews.2.author": "سارة الخالدي",
  "gccGuide.reviews.2.date": "فبراير 2025",
  "gccGuide.reviews.2.text": "زرت {{name}} مع عائلتي وكانت تجربة جميلة جداً. الأطفال أحبوا المكان كثيراً. الأسعار معقولة مقارنة بالجودة المقدمة، مع بعض الازدحام في عطلات نهاية الأسبوع.",
  "gccGuide.reviews.3.author": "خالد المنصوري",
  "gccGuide.reviews.3.date": "يناير 2025",
  "gccGuide.reviews.3.text": "من أفضل الأماكن التي زرتها في المنطقة. الجودة تفوق التوقعات والتفاصيل الدقيقة تدل على الاهتمام الحقيقي بالزوار. أنصح بالحجز المسبق لضمان أفضل تجربة.",
  "gccGuide.reviews.4.author": "نورة السعيد",
  "gccGuide.reviews.4.date": "ديسمبر 2024",
  "gccGuide.reviews.4.text": "تجربة رائعة بشكل عام. الموقع مثالي والمرافق ممتازة. أتمنى لو كانت ساعات العمل أطول قليلاً. سأزوره مرة أخرى في رحلتي القادمة.",
  "gccGuide.reviews.5.author": "عبدالله الراشد",
  "gccGuide.reviews.5.date": "نوفمبر 2024",
  "gccGuide.reviews.5.text": "زيارة لا تُنسى! كل شيء كان مثالياً من لحظة الوصول حتى المغادرة، والخدمة الراقية جعلت التجربة استثنائية.",
  "gccGuide.reviews.tags.excellentService": "خدمة ممتازة",
  "gccGuide.reviews.tags.clean": "نظافة عالية",
  "gccGuide.reviews.tags.greatLocation": "موقع مميز",
  "gccGuide.reviews.tags.familyFriendly": "مناسب للعائلات",
  "gccGuide.reviews.tags.fairPrices": "أسعار معقولة",
  "gccGuide.reviews.tags.enjoyable": "تجربة ممتعة",
  "gccGuide.reviews.tags.highQuality": "جودة عالية",
  "gccGuide.reviews.tags.worthVisiting": "يستحق الزيارة",
  "gccGuide.reviews.tags.professional": "احترافية",
  "gccGuide.reviews.tags.perfectLocation": "موقع مثالي",
  "gccGuide.reviews.tags.excellentFacilities": "مرافق ممتازة",
  "gccGuide.reviews.tags.refinedService": "خدمة راقية",
  "gccGuide.reviews.tags.memorable": "تجربة لا تُنسى",
  "gccGuide.reviews.tags.greatTeam": "طاقم متميز",

  // ── Trip Planner ──
  "seo.tripPlanner.title": "صمم رحلتك الخليجية | دليل الخليج - السياحية",
  "seo.tripPlanner.description": "خطط لرحلتك السياحية في دول الخليج العربي. اختر الفنادق والمطاعم والمعالم السياحية وصدّر خطة رحلتك كملف PDF.",
  "seo.tripPlanner.keywords": "تخطيط رحلة خليجية, صمم رحلتك, سياحة الخليج, خطة سفر",
  "tripPlanner.title": "صمم رحلتك",
  "tripPlanner.heroTitle": "✈️ صمم رحلتك",
  "tripPlanner.heroDescription": "اختر وجهتك ومدة رحلتك، ثم أضف الفنادق والمطاعم والمعالم — وصدّر خطتك كملف PDF أو احفظها للعودة إليها لاحقاً.",
  "tripPlanner.savedTrips": "رحلاتي المحفوظة",
  "tripPlanner.newTrip": "رحلة جديدة",
  "tripPlanner.clearAll": "مسح الكل",
  "tripPlanner.updateTrip": "تحديث الرحلة",
  "tripPlanner.saveTrip": "حفظ الرحلة",
  "tripPlanner.update": "تحديث",
  "tripPlanner.editing": "تعديل:",
  "tripPlanner.tripInfo": "معلومات الرحلة",
  "tripPlanner.tripName": "اسم الرحلة",
  "tripPlanner.tripNamePlaceholder": "مثال: رحلة دبي الصيفية",
  "tripPlanner.tripNamePlaceholderLong": "مثال: رحلة دبي الصيفية 2025",
  "tripPlanner.travelerName": "اسم المسافر",
  "tripPlanner.travelerNamePlaceholder": "اسمك أو اسم المجموعة",
  "tripPlanner.updateSavedTrip": "تحديث الرحلة المحفوظة",
  "tripPlanner.destination": "الوجهة",
  "tripPlanner.duration": "مدة الرحلة",
  "tripPlanner.durationWarning": "تحذير: يوجد أنشطة في الأيام من {{from}} إلى {{to}}",
  "tripPlanner.daysCount": "{{count}} يوم",
  "tripPlanner.tripDurationPrefix": "رحلة مدتها",
  "tripPlanner.inDestination": "في {{country}}",
  "tripPlanner.selectedDestination": "الوجهة المختارة",
  "tripPlanner.durationAffectedHint": "الأزرار البرتقالية تحتوي على أنشطة ستتأثر",
  "tripPlanner.tripSummary": "ملخص الرحلة",
  "tripPlanner.stats.days": "عدد الأيام",
  "tripPlanner.stats.activities": "إجمالي الأنشطة",
  "tripPlanner.availableIn": "المتاح في {{country}}",
  "tripPlanner.schedule": "برنامج الرحلة",
  "tripPlanner.map": "خريطة الرحلة",
  "tripPlanner.addDayHint": "اضغط على أي يوم لإضافة أنشطة",
  "tripPlanner.noActivitiesTitle": "لا توجد أنشطة بعد",
  "tripPlanner.noActivitiesMapDescription": "أضف أنشطة من تبويب البرنامج لتظهر على الخريطة",
  "tripPlanner.goToSchedule": "انتقل إلى البرنامج",
  "tripPlanner.readyTitle": "رحلتك جاهزة! 🎉",
  "tripPlanner.readyDescription": "لديك {{activities}} نشاط موزعة على {{days}} يوم في {{country}}",
  "tripPlanner.shareTrip": "مشاركة الرحلة",
  "tripPlanner.toast.durationReducedMoved": "تم تقليل الرحلة إلى {{duration}} يوم مع نقل الأنشطة ✓",
  "tripPlanner.toast.durationReduced": "تم تقليل الرحلة إلى {{duration}} يوم",
  "tripPlanner.toast.updated": "تم تحديث الرحلة بنجاح ✓",
  "tripPlanner.toast.updateError": "حدث خطأ أثناء التحديث",
  "tripPlanner.toast.saved": "تم حفظ الرحلة بنجاح ✓",
  "tripPlanner.toast.saveError": "حدث خطأ أثناء الحفظ",
  "tripPlanner.toast.loaded": "تم تحميل رحلة \"{{name}}\" ✓",
  "tripPlanner.toast.deleted": "تم حذف الرحلة",
  "tripPlanner.toast.newTrip": "تم إنشاء رحلة جديدة",
  "tripPlanner.myTrip": "رحلتي",
  "tripPlanner.saveModal.saveDescription": "احفظ رحلتك للعودة إليها لاحقاً",
  "tripPlanner.saveModal.updateDescription": "تحديث بيانات الرحلة الحالية",
  "tripPlanner.saveModal.browserNote": "ستُحفظ رحلتك تلقائياً في هذا المتصفح. يمكنك العودة إليها في أي وقت من قسم رحلاتي المحفوظة.",
  "tripPlanner.saveModal.saving": "جاري الحفظ...",
  "tripPlanner.addItem.title": "إضافة نشاط للرحلة",
  "tripPlanner.addItem.searchPlaceholder": "ابحث بالاسم أو الموقع...",
  "tripPlanner.shareModal.shareText": "شاهد خطة رحلتي إلى {{country}}{{name}} عبر دليل الخليج السياحي!",
  "tripPlanner.shareModal.subtitle": "أرسل رابط رحلتك لأصدقائك",
  "tripPlanner.shareModal.saveFirstTitle": "احفظ الرحلة أولاً",
  "tripPlanner.shareModal.saveFirstDescription": "لمشاركة رحلتك، يجب حفظها أولاً حتى يتمكن أصدقاؤك من رؤيتها.",
  "tripPlanner.shareModal.saveNow": "حفظ الرحلة الآن",
  "tripPlanner.shareModal.uniqueLink": "{{country}} · رابط مشاركة فريد",
  "tripPlanner.shareModal.shareLink": "رابط المشاركة",
  "tripPlanner.shareModal.shareVia": "مشاركة عبر",
  "tripPlanner.shareModal.nativeShare": "مشاركة عبر التطبيقات الأخرى",
  "tripPlanner.shareModal.linkPrivacy": "أي شخص يملك هذا الرابط يستطيع عرض رحلتك. لا يمكنه التعديل عليها.",
  "tripPlanner.dayNumber": "اليوم {{number}}",
  "tripPlanner.dayMapTitle": "اليوم {{number}} — الخريطة",
  "tripPlanner.activitiesCount": "{{count}} نشاط",
  "tripPlanner.mapLocationsCount": "{{count}} موقع على الخريطة",
  "tripPlanner.allLocations": "الكل ({{count}})",
  "tripPlanner.noDayActivities": "لا توجد أنشطة في هذا اليوم",
  "tripPlanner.openInGoogleMaps": "فتح في خرائط Google",
  "tripPlanner.mapIframeTitle": "خريطة اليوم {{number}}",
  "tripPlanner.dragActivity": "اسحب لنقل النشاط",
  "tripPlanner.notePlaceholder": "ملاحظة (اختياري)...",
  "tripPlanner.moving": "جارٍ النقل...",
  "tripPlanner.moreActivities": "{{count}} أنشطة أخرى",
  "tripPlanner.reorderDay": "اسحب لإعادة ترتيب اليوم",
  "tripPlanner.dragActivities": "اسحب الأنشطة للنقل",
  "tripPlanner.addActivity": "إضافة نشاط",
  "tripPlanner.dropHereMove": "أفلت هنا لنقل النشاط",
  "tripPlanner.emptyDayHint": "اضغط لإضافة فندق أو مطعم أو معلم",
  "tripPlanner.dropHere": "أفلت هنا",
  "tripPlanner.savedPanel.emptyTitle": "لا توجد رحلات محفوظة بعد",
  "tripPlanner.savedPanel.emptyDescription": "احفظ رحلتك الحالية لتجدها هنا",
  "tripPlanner.savedPanel.current": "الحالية",
  "tripPlanner.savedPanel.load": "تحميل الرحلة",
  "tripPlanner.savedPanel.confirmDelete": "تأكيد الحذف",
  "tripPlanner.savedPanel.delete": "حذف الرحلة",
  "tripPlanner.durationModal.title": "تغيير مدة الرحلة",
  "tripPlanner.durationModal.fromTo": "من {{from}} إلى {{to}} أيام",
  "tripPlanner.durationModal.warningTitle": "يوجد {{count}} نشاط في الأيام المحذوفة",
  "tripPlanner.durationModal.warningDescription": "الأيام من {{from}} إلى {{to}} تحتوي على أنشطة. ماذا تريد أن تفعل بها؟",
  "tripPlanner.durationModal.moveToDay": "نقل الأنشطة لليوم {{day}}",
  "tripPlanner.durationModal.moveDescription": "سيتم نقل جميع الأنشطة من الأيام المحذوفة إلى آخر يوم في الرحلة الجديدة",
  "tripPlanner.durationModal.discardTitle": "حذف الأنشطة الزائدة",
  "tripPlanner.durationModal.discardDescription": "سيتم حذف {{count}} نشاط نهائياً من الأيام المحذوفة",
  "tripPlanner.durationModal.cancel": "إلغاء — الإبقاء على {{duration}} أيام",
  "seo.sharedTrip.title": "{{name}} | دليل الخليج - السياحية",
  "seo.sharedTrip.defaultTitle": "رحلة مشتركة | دليل الخليج",
  "seo.sharedTrip.description": "خطة رحلة إلى {{country}} لمدة {{duration}} أيام تضم {{activities}} نشاطاً سياحياً.",
  "seo.sharedTrip.defaultDescription": "عرض خطة رحلة سياحية في دول الخليج",
  "seo.sharedTrip.keywords": "خطة رحلة, سياحة الخليج, دليل السياحة",
  "tripPlanner.shared.loading": "جاري تحميل الرحلة...",
  "tripPlanner.shared.notFoundTitle": "الرحلة غير موجودة",
  "tripPlanner.shared.notFoundDescription": "هذا الرابط غير صالح أو تم حذف الرحلة من قِبل صاحبها.",
  "tripPlanner.shared.createOwn": "صمم رحلتك الخاصة",
  "tripPlanner.shared.sharedTrip": "رحلة مشتركة",
  "tripPlanner.shared.createOwnTitle": "صمم رحلتك الخاصة!",
  "tripPlanner.shared.createOwnDescription": "أعجبتك هذه الرحلة؟ صمم رحلتك الخاصة إلى الخليج الآن.",
  "tripPlanner.shared.startPlanning": "ابدأ التخطيط",
  "tripPlanner.shared.shareText": "شاهد خطة رحلة \"{{name}}\" إلى {{country}}",
  "tripPlanner.shared.shortShareText": "شاهد خطة رحلة \"{{name}}\"",
  "tripPlanner.pdf.scanToShare": "امسح الرمز لمشاركة الرحلة",
  "tripPlanner.pdf.coverStats": "{{days}} أيام | {{activities}} نشاط",
  "tripPlanner.pdf.preparedFor": "أعدّ ل: {{name}}",
  "tripPlanner.pdf.scanDescription": "امسح رمز QR لفتح خطة الرحلة ومشاركتها مع أصدقائك وعائلتك",
  "tripPlanner.pdf.allActivities": "قائمة جميع الأنشطة",
  "tripPlanner.pdf.exporting": "جاري التصدير...",
  "tripPlanner.pdf.export": "تصدير PDF",
  "tripPlanner.pdf.travelTipsFor": "نصائح السفر إلى {{country}}",
  "tripPlanner.pdf.importantInfo": "معلومات مهمة قبل سفرك",
  "tripPlanner.pdf.currency": "العملة",
  "tripPlanner.pdf.language": "اللغة",
  "tripPlanner.pdf.timezone": "التوقيت",
  "tripPlanner.pdf.bestSeason": "أفضل موسم",
  "tripPlanner.pdf.emergency": "الطوارئ",
  "tripPlanner.pdf.visa": "التأشيرة",
  "tripPlanner.pdf.importantTips": "نصائح مهمة للمسافر",
  "tripPlanner.pdf.do": "افعل",
  "tripPlanner.pdf.dont": "تجنّب",
  "tripPlanner.pdf.usefulPhrases": "عبارات مفيدة",

  // ── Opinion Pages ──
  "seo.opinionList.title": "مقالات الرأي | السياحية",
  "seo.opinionList.description": "مقالات الرأي والتحليلات في صحيفة السياحية — آراء كبار الكتاب والمحللين في قطاع السياحة والسفر",
  "seo.opinionList.keywords": "مقالات الرأي, تحليلات سياحية, رأي, السياحة, السفر, الخليج",
  "seo.opinionArticle.title": "مقال رأي | السياحية",
  "seo.opinionArticle.detailTitle": "{{title}} | مقالات الرأي | السياحية",
  "seo.opinionArticle.description": "مقالات الرأي في صحيفة السياحية",
  "seo.opinionArticle.keywords": "مقالات الرأي, {{author}}, السياحة, رأي",
  "opinion.specialSection": "قسم خاص",
  "opinion.listSubtitle": "آراء وتحليلات كبار الكتاب والمحللين في قطاع السياحة والسفر — رؤى عميقة ووجهات نظر مستنيرة",
  "opinion.authorCount": "{{count}} كاتب",
  "opinion.searchPlaceholder": "بحث في مقالات الرأي...",
  "opinion.noArticles": "لا توجد مقالات رأي",
  "opinion.notFoundTitle": "المقال غير موجود",
  "opinion.notFoundDescription": "ربما تم حذف المقال أو تغيير رابطه",
  "opinion.articleBadge": "مقال رأي",
  "opinion.likesCount": "{{count}} إعجاب",
  "opinion.defaultAuthorBio": "كاتب متخصص في مجال السياحة والسفر، يشارك رؤاه وتحليلاته في صحيفة السياحية.",
  "opinion.otherArticles": "مقالات رأي أخرى",
  "opinion.articleStats": "إحصائيات المقال",
  "opinion.views": "المشاهدات",
  "opinion.likes": "الإعجابات",
  "opinion.wordCount": "عدد الكلمات",
  "opinion.wordsCount": "{{count}} كلمة",
  "opinion.readingTime": "وقت القراءة",
  "opinion.minutesCount": "{{count}} دقائق",
  "opinion.newsletterDescription": "احصل على أهم مقالات الرأي أسبوعياً",
};

export default ar;
